import React from 'react'
import './SectionTitle.css'

const SectionTitle = ({ title }) => <h3 className="section_title">{title}</h3>

export default SectionTitle
